import { useParams, Navigate } from "react-router-dom";
import { Breadcrumbs } from "@/components/Breadcrumbs";
import { SizeSelector } from "@/components/SizeSelector";
import { ColourSwatches, CustomColourPrompt } from "@/components/ColourSwatches";
import { SeeInPerson } from "@/components/SeeInPerson";
import { PurchaseSteps } from "@/components/PurchaseSteps";
import { img } from "@/lib/site";
import { VENEERS } from "@/lib/timber";
import { FINISHES, finishImage } from "@/lib/panels";

export default function VeneerDetail() {
  const { sub } = useParams();
  const data = VENEERS[sub];
  if (!data) return <Navigate to="/collections/timber/veneers" replace />;

  return (
    <div data-testid="veneer-detail">
      <Breadcrumbs
        items={[
          { label: "Our Collection", to: "/collection" },
          { label: "Timber Collection", to: "/collections/timber" },
          { label: "Veneers", to: "/collections/timber/veneers" },
          { label: data.name },
        ]}
      />

      <section className="edge pt-8 pb-12 md:pt-12" data-testid="veneer-detail-head">
        <span className="eyebrow">Veneers</span>
        <h1 className="mt-5 text-4xl font-light leading-[1.02] tracking-editorial md:text-6xl">
          {data.name}
        </h1>
        <p className="mt-6 max-w-2xl text-base leading-relaxed text-muted-foreground md:text-lg">
          {data.intro}
        </p>
      </section>

      <section className="edge pb-24 md:pb-32" data-testid="veneer-detail-body">
        <div className="flex flex-col items-center py-10 text-center">
          <img
            src="/assets/logo.png"
            alt="House of David"
            className="h-20 w-auto opacity-90 md:h-24"
            data-testid="veneer-coming-soon-logo"
          />
          <p className="mt-8 text-2xl font-light tracking-editorial md:text-3xl" data-testid="veneer-coming-soon">
            Coming Soon
          </p>
        </div>
      </section>
    </div>
  );
}
